module.exports = __webpack_public_path__ + "img/gen-key.e84e3613.svg";